module.exports = __webpack_public_path__ + "static/media/solution-img1.f61abaef.png";